class CartCount extends Theme.Component {

  connectedCallback() {
    document.addEventListener("addtocart", (event) => {
      const count = Number(this.elements.count.textContent) + 1;

      this.update(count);
      this.toggleVisibility(count);
    });

    document.addEventListener("cart:change", (event) => {
      const count = event.detail.item_count;

      this.update(count);
      this.toggleVisibility(count);
    });
  }

  update(count) {
    this.elements.count.textContent = count;
  }

  toggleVisibility(count) {
    if (count > 0) {
      this.classList.remove("visibility--hidden");
    } else {
      this.classList.add("visibility--hidden");
    }
  }
}

customElements.define("component-cart-count", CartCount);